'use client';

import { useAssistantUrlParams } from '../hooks/useAssistantUrlParams';

/**
 * Component that handles URL parameters for opening the AI assistant.
 * Must be placed inside AssistantProvider.
 *
 * Renders nothing - just processes URL params on mount.
 */
export const AssistantUrlParamsHandler = () => {
  useAssistantUrlParams();
  return null;
};
